import React, { Component } from "react"

import { RadioSelect } from '../../elements/RadioSelect/RadioSelect'
import { familyStatus, one2seven } from '../../variables/ComboValues'
import { updateElement } from "../Tree/Utils.js"
import { InputF, TextareaF, SelectF } from '../../elements/FormFields'
import { CalendarDay2 } from '../../elements/DayPicker/DayPicker2'

//import { ParentEmployment } from "./ParentEmployment";
//import { digmaDate, searchTableFilter } from "./Utils.js"
//import { EditableCell } from "../TableList/EditableCell"

// input (props) 
//      tableTitle={"תוכנית עבודה"}
//      familyCode - TBD
// Resources: see import above

// TODO: get data from DB && Update to DB

const  microLegend = {
  "id": "מספר השאלון",
  "interviewer": "מראיין",
  "date": "תאריך מילוי השאלון",
  "family_status": "סטטוס המשפחה",
  "intro": "חוות דעת",
  "q1": "חוות דעת מלווה/ת משפחה",
  "q2": "חוות דעת אשה",
  "q3": "חוות דעת גבר",
  "q4": "כלכלת משפחה",
  "q5": "מיצוי זכויות",
  "q6": "תעסוקת אשה",
  "q7": "תעסוקת גבר",
  "q8": "משפחה",
  "q9": "העצמה אישית אשה",
  "q10": "העצמה אישית גבר",
  "q11": "יחסים זוגיים",
  "q12": "הורות",
  "q13": "חיזוק רשת תמיכה",
  "q14": "המשפחה כמכלול",
  "q15": "ילדים",
  "q16": "מטרה אחרת"
}
export const questionnareFields = microLegend
export class FamilyProgramQ extends Component {

    constructor(props) {
      super(props)
      this.state = { products: this.props.data }
      //this.onSaveTable = this.onSaveTable.bind(this)
      //this.handleProductTable = this.handleProductTable.bind(this)
      //console.log("QQ", this.props.data.bench_stat)
    }
    handleProductTableDate = (day, key)  => {
      var newp = Object.assign(this.state.products)
      newp[key] = day
      this.setState({products:newp})
    }
    handleProductTable= (evt) => {
        evt.preventDefault()
        var newp= updateElement(evt, this.state.products)
        this.setState({products:newp})
    }

    // update data base
    onSaveTable = (evt) => {
      evt.preventDefault()
      const { save2DB, subTableId, familyPostId, inUpdate, mbouser } = this.props
      // console.log("Family General save table: products", this.state.products)
      save2DB(familyPostId, this.state.products, subTableId, "group", inUpdate, mbouser )
    }
    render() {
      const {tableTitle} = this.props
      // const { data } = this.props
      // console.log("Family general data", data)
      // console.log("OLD meeting data", this.state.products)
      if (typeof this.props.data === "undefined"){
        // console.log("Parent Questionnair - props", this.props)
        return <h1>Internal Error: Missing data in this props data</h1>
      }
      return (
          <ProductTable 
            onProductTableUpdate={this.handleProductTable}
            onSaveTable={this.onSaveTable} 
            tableTitle = {tableTitle} // "סיכומי מפגשים"
            products={this.state.products} 
            onProductTableDate={this.handleProductTableDate}
          />
      )
    }
  }
   
  class ProductTable extends Component {
    constructor(props){
        super(props)
        this.state={
            filterText : "",
            detailedDisplay: false
        }
        this.toggleDisplay = this.toggleDisplay.bind(this)
    }
    toggleDisplay(evt){
      let tog = !this.state.detailedDisplay
      this.setState({detailedDisplay: tog})
      // console.log("toggleDisplay - now= ", tog ?"true":"false")
    }
    handleUserInput(filterText) {
        this.setState({filterText: filterText});
    }
    render() {
      const { onProductTableUpdate, products, tableTitle, onSaveTable, onProductTableDate } = this.props
      var buttonStyle = {marginRight: '0'}
      // console.log("General - products", products)
      const product = products
     
      const cellData=[{
        type: "text",
        name: "interviewer",
        value: product.interviewer,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "date",
        name: "date",
        value: product.date,
        id: product.id,
        style: {width: "100px"},
        placeholder: 'dd/mm/yyyy',
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: familyStatus, // ["משתתפת", "בהפסקה","נושרת", "מסיימת בהסכמה לפני המועד","בוגרת", "אחר"],
        name: "family_status",
        value: product.family_status,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "textarea",
        name: "intro",
        value: product.intro,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        newsection: "חוות דעת",
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: one2seven, // ["1", "2","3", "4","5", "6", "7"],
        name: "q1",
        value: product.q1,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: one2seven, //["1", "2","3", "4","5", "6", "7"],
        name: "q2",
        value: product.q2,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: one2seven, // ["1", "2","3", "4","5", "6", "7"],
        name: "q3",
        value: product.q3,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        newsection: "פירוט מילולי של שינויים עובדתיים",
        type: "textarea",
        name: "q4",
        value: product.q4,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "textarea",
        name: "q5",
        value: product.q5,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "textarea",
        name: "q6",
        value: product.q6,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "textarea",
        name: "q7",
        value: product.q7,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "textarea",
        name: "q8",
        value: product.q8,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "textarea",
        name: "q9",
        value: product.q9,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "textarea",
        name: "q10",
        value: product.q10,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "textarea",
        name: "q11",
        value: product.q11,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "textarea",
        name: "q12",
        value: product.q12,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "textarea",
        name: "q13",
        value: product.q13,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "textarea",
        name: "q14",
        value: product.q14,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "textarea",
        name: "q15",
        value: product.q15,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "textarea",
        name: "q16",
        value: product.q16,
        id: product.id,
        style: {width: "100px"},
        edit: true
      }] 

      return (
        <div className="yahav-modal">
            <h2 className="sub-tab-title">{tableTitle}</h2>
            
            <button style={buttonStyle} type="button"  className="btn btn-success pull-left" onClick={onSaveTable}>עדכון</button>
            
            <div className="mynewdivform width1140 evenodd family-qend" >
                <button  type="button"  className="btn btn-success pull-left" 
                    onClick={this.toggleDisplay}>שינוי תצוגה</button>
                <ProductRow 
                    onProductTableUpdate={onProductTableUpdate} 
                    product={product} 
                    cd={cellData}
                    detailedDisplay = {this.state.detailedDisplay}
                    onProductTableDate = { onProductTableDate}
                    />
            </div>
        </div>
      )
    }
  }

class ProductRow extends React.PureComponent {
    
    render() {
      const {onProductTableUpdate, cd, detailedDisplay, onProductTableDate} = this.props
      var key = 0;
      return (
        <div className="eachRow">
          {cd.map(cellInfo => {
              if (cellInfo.newsection !== undefined)
                return(
                <React.Fragment key={key++}>
                  <h3 key={key++} >{cellInfo.newsection}</h3>
                  <EditableFormCell key={key++} onProductTableUpdate={onProductTableUpdate} 
                              onProductTableDate={onProductTableDate} cellData={cellInfo} detailedDisplay={detailedDisplay} />
                </React.Fragment>
                )
              return (<EditableFormCell key={key++} onProductTableUpdate={onProductTableUpdate} 
                              onProductTableDate={onProductTableDate} cellData={cellInfo} detailedDisplay={detailedDisplay} /> )
          })}
        </div>
      )
    }
  }

  class EditableFormCell extends React.Component {
    handleChange = changeEvent => {
      this.setState({date: changeEvent.target.value})
    }
    render() {
        const tp = this.props
        const detailedDisplay = tp.detailedDisplay
        const tpc = tp.cellData
        const divStyleBblock = {padding: 0, verticalAlign: 'top', borderTop: 0, display: 'block', margin: '0 3px 5px 8px' }
        const labelStyle = {width: '45%', verticalAlign: 'top'}
        //const qnumStyle = {marginLeft: '5px', width:'40px', textAlign:'left', display:'inline-block', verticalAlign: 'top'}
        //const qnum = tpc.name.replace('intake_','').replace('other','o')
        //console.log("EditableFormCell tpc.name"+ tpc.name + "m[tpcanme]", microLegend[tpc.name])
        //console.log("EditableFormCell tpc", tpc)
        if (tpc.type === "date"){
          return (
             <div className="form-cell-box-inline">
               <label htmlFor={tpc.id}>{microLegend[tpc.name]}</label>
               {<CalendarDay2
                   tpc = {tpc}
                   value = {tpc.value}
                   selected={new Date()}
                   onChange={this.handleChange}
                   handleChangeDate={tp.onProductTableDate} // {this.handleChangeDate}
               />}
             </div>
           )
        }
        if (tpc.type === "radioSelect" || tpc.type === "select"){
          if (detailedDisplay)
            tpc.type = "radioSelect"
          else
            tpc.type = "select"
        }
        if (tpc.type === "radioSelect")
          return (
            <div className="form-line" style={divStyleBblock}>
              {/* <span style={qnumStyle}>{qnum}</span> */}
              <label style={labelStyle} htmlFor={tpc.id}>{microLegend[tpc.name]}</label>
              <RadioSelect value={tpc.value} options={tpc.options} onChange={tp.onProductTableUpdate} id={tpc.id} name={tpc.name} />
            </div>
          )
        if (tpc.type === "select"){
          return(
            <div className="form-line" style={divStyleBblock}>
              <label style={labelStyle} htmlFor={tpc.id}>{microLegend[tpc.name]}</label>
              <SelectF tp={tp} tpc={tpc} overstyle={{ display: 'inline-block'}} />
              {/*<select style={{display: 'inline-block'}} name={tpc.name} id={tpc.id} value={tpc.value} onChange={tp.onProductTableUpdate} > 
                <option key={1111111} value="נא לבחור" > נא לבחור </option>
                {
                tpc.options.map(item => {
                    return(<option key={item} value={item}>{item}</option>)
                    })
                }
              </select>
              <br />*/}
            </div>
          )
        }
        if (tpc.type === "textarea"){
          return(
            <div className="form-line" style={divStyleBblock}>
              <label style={labelStyle}  htmlFor={tpc.id}>{microLegend[tpc.name]}</label>
              <TextareaF tp={tp} tpc={tpc} overstyle={{ width:'40%'}} />
            </div>
          )
        }
        return (
            <div className="form-line" style={divStyleBblock}>
              <label style={labelStyle} htmlFor={tpc.id}>{microLegend[tpc.name]}</label>
              <InputF tp={tp} tpc={tpc} />
            </div>
        )
  
    }
  }

     
  